const SvgArrowBackBold = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24">
    <path fill="#373737" fillRule="evenodd" d="m10.62 1 1.403 1.452-8.224 8.517 20.197-.04.004 2.053-20.21.04 8.233 8.526L10.62 23 0 12z" clipRule="evenodd" />
  </svg>;
export default SvgArrowBackBold;